module.exports = __webpack_public_path__ + "static/media/embed_type_questionnaire.6f4a3911.svg";